import { render, staticRenderFns } from "./Recognize.vue?vue&type=template&id=f11fb1bc&scoped=true&"
import script from "./Recognize.vue?vue&type=script&lang=js&"
export * from "./Recognize.vue?vue&type=script&lang=js&"
import style0 from "./Recognize.vue?vue&type=style&index=0&id=f11fb1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11fb1bc",
  null
  
)

export default component.exports